import React from 'react';
import PropTypes from 'prop-types';

import { priceFormatSeparate } from 'apps/products/utils/priceFormat';

const BasketSummary = ({ basket, items }) => {
  if (!items || !items.length) {
    return null;
  }

  const [basketValue, basketValueFraction] = priceFormatSeparate({ value: basket.value, inPound: true });
  return (
    <p className="hd-trolleyMenu__basketSummary">
      <span className="hd-trolleyMenu__basketSummaryLabel">Total</span>
      <span className="hd-trolleyMenu__basketSummaryValue">
        {basketValue}<span className="hd-trolleyMenu__basketSummaryValueFraction">{basketValueFraction}</span>
      </span>
    </p>
  );
};

BasketSummary.propTypes = {
  basket: PropTypes.object.isRequired,
  items: PropTypes.array.isRequired,
};

export default BasketSummary;
